__turbopack_context__.v({
  "dropdown_btn": "GBVROG_dropdown_btn",
});
